/* istanbul ignore file */
import { DEFAULT_ENTITY_AUTHOR } from 'domain/shared/core/constants';
import { EntityHeader } from 'framework/ui/layout';

const AssetHeader = () => <EntityHeader entityTitleSource="inventoryNumber" defaultAuthor={DEFAULT_ENTITY_AUTHOR} />;

export default AssetHeader;
